import React, { ReactNode } from 'react';
import styles from './style.module.css';

export type Size = 'small' | 'medium' | 'big';
export type Variant =
  | 'info'
  | 'success'
  | 'secondary'
  | 'danger'
  | 'warning'
  | 'disabled';

export type IProps = {
  size?: Size;
  variant?: Variant;
  label?: string;
  icon?: ReactNode;
};

const Badge: React.FC<IProps> = ({
  size = 'medium',
  variant = 'info',
  icon,
  label = 'Label',
}) => {
  return (
    <div
      className={`flex-row gap-s ${styles.badge} ${styles[size]} ${styles[variant]}`}
    >
      {icon && icon}
      {label}
    </div>
  );
};

export default Badge;
